export default "__VITE_ASSET__C897HwMA__"